var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'card',
    ( _obj = {}, _obj[("card--shadow-" + _vm.shadow)] = _vm.shadow, _obj[("card--background-" + _vm.background)] = _vm.background, _obj[("card--padding-" + _vm.padding)] = _vm.padding, _obj ) ]},[(_vm.title)?_c('div',{staticClass:"card__header"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"card__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }